import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { generatePositionTableRow } from '../CallsheetUtils';
import styles from '../../../assets/stylesheets/CallsheetInlineStyles';
import i18n from '../../../i18n';
import { employeePositions } from '../../../constants/employeePositions';

class MerchandiseSheet extends Component {
  render() {
    const { name, info, renderForEmail } = this.props;
    return (
      <table
        border="1"
        style={renderForEmail ? styles.tableEmailWidth : styles.tableFullWidth}
      >
        <thead>
          <tr>
            <th style={styles.locationHeader} colSpan="4">
              <h4>{name}</h4>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th colSpan="2">{i18n.t('setting:callTime')}</th>
            <th colSpan="2">{i18n.t('setting:wrapTime')}</th>
          </tr>
          <tr>
            <td colSpan="2" style={styles.timeCell}>
              {info.callTime}
            </td>
            <td colSpan="2" style={styles.timeCell}>
              {info.wrapTime}
            </td>
          </tr>
          {generatePositionTableRow(
            'stylingRoomCoordinators',
            info.positions[employeePositions.STYLING_ROOM_COORDINATOR]
          )}

          {generatePositionTableRow(
            'womenswearMerchandiseCoordinators',
            info.positions[employeePositions.WOMENSWEAR_MERCHANDISE_COORDINATOR]
          )}

          {generatePositionTableRow(
            'menswearMerchandiseCoordinators',
            info.positions[employeePositions.MENSWEAR_MERCHANDISE_COORDINATOR]
          )}

          {generatePositionTableRow(
            'accMerchandiseCoordinators',
            info.positions[employeePositions.ACC_MERCHANDISE_COORDINATOR]
          )}

          {generatePositionTableRow(
            'copyMerchandiseCoordinators',
            info.positions[employeePositions.COPY_MERCHANDISE_COORDINATOR]
          )}

          {generatePositionTableRow(
            'studioAssistantCoordinators',
            info.positions[employeePositions.STUDIO_ASSISTANT_COORDINATOR]
          )}
        </tbody>
      </table>
    );
  }
}

MerchandiseSheet.propTypes = {
  name: PropTypes.string.isRequired,
  info: PropTypes.shape({
    callTime: PropTypes.string.isRequired,
    wrapTime: PropTypes.string.isRequired,
    positions: PropTypes.objectOf(
      PropTypes.shape({
        employees: PropTypes.arrayOf(
          PropTypes.shape({ email: PropTypes.string, name: PropTypes.string })
        )
      })
    )
  }).isRequired,
  renderForEmail: PropTypes.bool.isRequired
};

export default MerchandiseSheet;
